import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { modalType, modalOpen } from '../../redux/actions';
import Group from '../Group';
import Button from '../Button';
import Text from '../Text';
import TextField from '../TextField';
import theme, { rem } from '../../theme';
import firebase from '../../firebase';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
`;

const StyledText = styled(Text)`
  margin-bottom: ${rem(10)};
`;

const StyledContentWrapper = styled(Group)`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
`;

const StyledGroup = styled(Group)`
  flex-direction: column;
  margin-bottom: ${rem(10)};

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledButton = styled(Button)`
  margin: ${rem(20)} 0;
`;

const StyledErrorText = styled(Text)`
  background-color: salmon;
  color: darkred;
  padding: 8px;
  border-radius: 2px;
  border: 1px solid darkred;
  margin-top: 7px;
`;

const StyledSuccessText = styled(Text)`
  background-color: darkseagreen;
  color: darkgreen;
  padding: 8px;
  border-radius: 2px;
  border: darkgreen;
  margin-top: 7px;
`;

/** reset password modal */
const resetPassword = props => {
  //refs
  const emailRef = useRef();

  //states
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  //firebase auth
  const auth = firebase.auth();

  /** reset password helper function */
  const resetPasswordHelper = emailAddress => {
    setErrorMessage('');
    setSuccessMessage('');
    auth
      .sendPasswordResetEmail(emailAddress)
      .then(function() {
        setSuccessMessage(
          'Email send succesfully. You may close this screen or go back to login'
        );
      })
      .catch(function(error) {
        setErrorMessage(error.message);
      });
  };

  return (
    <StyledWrapper>
      <StyledContentWrapper fullwidth>
        <StyledText
          align="center"
          text="Reset your password"
          textColor="#fff"
          textStyle="h4"
          tag="h3"
        />
        <StyledGroup fullwidth>
          <Text
            align="left"
            text="Email"
            textStyle="description"
            textColor="#fff"
          />
          <TextField
            placeholdercolor="#fff"
            backgroundcolor={theme.color.dark[40]}
            isFocused
            textcolor="#fff"
            inputId="modalEmail"
            placeholder=""
            borders={false}
            value=""
            ref={emailRef}
            type="email"
          />
        </StyledGroup>
        <Text
          align="left"
          text="An email with further instructions will be send to your email adress"
          textColor="#fff"
        />
        {errorMessage && <StyledErrorText align="left" text={errorMessage} />}
        {successMessage && (
          <StyledSuccessText align="left" text={successMessage} />
        )}
        <StyledButton
          fullWidth
          text={{
            text: 'Send',
            textColor: '#fff',
            align: 'center',
            textStyle: 'overline',
          }}
          bgColor={theme.color.primary[100]}
          onClick={() => {
            resetPasswordHelper(emailRef.current.value);
          }}
        />
        <Text
          onClick={() => {
            props.modalOpen(true);
            props.modalType(['login']);
          }}
          align="left"
          text="Go back"
          textColor="#fff"
          tag="a"
          inline
        />
      </StyledContentWrapper>
    </StyledWrapper>
  );
};

export default connect(null, {
  modalType,
  modalOpen,
})(resetPassword);
